import { Step as _Step } from './Step'
import { Preview } from './Preview'
import { TitleWithOptions } from './TitleWithOptions'

export const Step = Object.assign(_Step, {
  Preview,
  TitleWithOptions
})
